import { IssueProduct } from "./issue-product";
import { Product } from "./product";
import { SystemField } from "./system-field";

export class IssueProductDetail extends SystemField { 
     product_id?:string;
     trans_uom_id?:string;
     base_uom_id?:string;
     qty?:number;
     location_id?:string;
     issue_prod_id?:string;
     
     unit_price?:number;
     unit_cost?:number;
     discount_amt?:number;
     discount_rate?:number;

     //formula fields
     total_cost?:number;

     //relationship

     //parents

     //children
     langs?:any;
     product?:Product;
     issue_product?:IssueProduct;
}
export class IssueProductDetailTranslate extends SystemField{ 
     lang_code?:string;
     issue_prod_detail_id?:string;
     description?:string;
}
